import React, { useEffect } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form, Input } from "antd";

import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
const CreateNewSMSBotProbeModal: React.FC<GeneralModalProps> = ({
  show,
  handleClose,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<CreateNewSMSBotProbeApiProp>(
    "bots/createNewSmsProbeBot",
    true
  );

  const onFinish = (values: any) => {
    const { probePassword, probeUserName, probeName } = values;
    const dataToSend: CreateNewSMSBotProbeApiProp = {
      probePassword,
      probeUserName,
      probeName,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <NetwalaModal
        title="New SMS Probe"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="createNewSMSBotProbeForm"
            >
              <Form.Item
                label={<span className="create-user-form-label">Name</span>}
                name="probeName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Name",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Name"
                />
              </Form.Item>
              <Form.Item
                label={<span className="create-user-form-label">Username</span>}
                name="probeUserName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter username",
                  },
                  {
                    pattern: /^\S+$/,
                    message: "username cannot contain spaces",
                  },
                  {
                    min: 3,
                    message: "username should be at least 3 characters",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="username"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Password</span>}
                name="probePassword"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Password",
                  },
                  {
                    pattern: /^\S+$/,
                    message: "Password cannot contain spaces",
                  },
                  {
                    min: 6,
                    message: "password should be at least 6 characters",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Password"
                  onChange={(e) => {
                    const noSpaces = e.target.value.replace(/\s+/g, "");
                    e.target.value = noSpaces;
                  }}
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Create"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default CreateNewSMSBotProbeModal;
